import React from 'react';
import { IconButton } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { panelCloseIconButtonSx } from '../PanelShell/PanelHeader';

// Este header usa una X ligeramente más compacta que Filtrar, conservando
// un área de interacción cómoda y los mismos estados visuales compartidos.
const mapToolPanelCloseIconButtonSx = {
  ...panelCloseIconButtonSx,
  width: 22,
  height: 22,
  minWidth: 22,
  p: '4px',
  '& .MuiSvgIcon-root': {
    fontSize: 16,
    width: 16,
    height: 16,
  },
};

/**
 * Cabecera de paneles flotantes del toolbar del mapa
 * (Vista del mapa, Capas de referencia, Puntos de interés).
 * Misma apariencia que el resto del chrome, con una X más compacta.
 *
 * @param {React.ElementType} [icon]
 * @param {string} title
 * @param {() => void} onClose
 * @param {boolean} [sticky] — header sticky al scrollear el panel
 * @param {string} [backgroundColor] — fondo cuando sticky / body con padding propio
 * @param {boolean} [padded] — padding horizontal propio (paneles cuyo body va aparte)
 */
const MapToolPanelHeader = ({
  icon: Icon = null,
  title,
  onClose,
  sticky = false,
  backgroundColor,
  padded = false,
}) => (
  <div
    style={{
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      gap: '8px',
      fontSize: '13px',
      fontWeight: 600,
      color: '#ffffff',
      borderBottom: '1px solid rgba(255,255,255,0.08)',
      boxSizing: 'border-box',
      ...(sticky
        ? { position: 'sticky', top: 0, zIndex: 1, backgroundColor }
        : { flexShrink: 0, ...(backgroundColor ? { backgroundColor } : null) }),
      ...(padded
        ? { padding: '12px' }
        : { paddingBottom: '12px', marginBottom: '2px' }),
    }}
  >
    <div
      style={{
        display: 'flex',
        alignItems: 'center',
        gap: '6px',
        minWidth: 0,
        whiteSpace: 'nowrap',
      }}
    >
      {Icon ? (
        <Icon style={{ fontSize: '15px', color: 'rgba(255,255,255,0.5)', flexShrink: 0 }} />
      ) : null}
      <span style={{ overflow: 'hidden', textOverflow: 'ellipsis' }}>{title}</span>
    </div>
    <IconButton
      onClick={onClose}
      size="small"
      aria-label="Cerrar"
      sx={mapToolPanelCloseIconButtonSx}
    >
      <CloseIcon />
    </IconButton>
  </div>
);

export default MapToolPanelHeader;
